// src/routes/index.js

import LoginPage from '../pages/Login/LoginPage';
import ForgetPwd from '../pages/ForgetPwd/ForgetPwd';
import ReSetPwd from '../pages/ForgetPwd/ReSetPwd';

import MultiCloudComplianceDashboard from '../pages/Cloud/MultiCloudComplianceDashboard';
import User from '../pages/Users/User';

import AdminManagement from '../pages/AdminManagement';
import CompanyBaseInfo from '../pages/Company/CompanyBaseInfo/CompanyBaseInfo';
import CompanyMember from '../pages/Company/CompanyMemberManagement/CompanyMemberManagement';
import ProcessManagementPage from '../pages/Company/ProcessManagement/ProcessManagementPage';
import CompanyOrgListBlock from '../pages/Company/CompOrgManagement/CompanyOrgListBlock';

import ProjectRoleManagement from '../pages/Project/ProjectRoleManagement/ProjectRoleManagement';
import ProjectMemberManagement from '../pages/Project/ProjectMemberManagement/ProjectMemberManagement';
import CloudConfigKey from '../pages/Project/Key/CloudConfigKey';
import ScanScheduleSetting from '../pages/Project/ScanSchedule/ScanScheduleSetting';

import SendAuthCard from '../pages/Company/CompanyBaseInfo/SendAuthCard';
import DocumentSnInfoManagement from '../pages/Project/DocumentSnInfo/DocumentSnInfoManagement';

import ComplianceOverview from '../pages/Cloud/ComplianceOverview';
import CSComplianceOverview from '../pages/CrowdStrike/ComplianceOverview';


/* =========================
  Public（登入相關）
========================= */
export const publicRoutes = [
  { path: "/", element: <LoginPage /> },
  { path: "/forget-password", element: <ForgetPwd /> },
  { path: "/resetpwd/:resetId", element: <ReSetPwd /> },
];


/* =========================
  所有人可進（登入後）
========================= */
export const commonRoutes = [
  { path: "/HomePage", element: <MultiCloudComplianceDashboard /> },
  { path: "/user", element: <User /> },

  // Azure
  { path: "/azure", element: <ComplianceOverview platform="azure" /> },

  // GCP
  { path: "/gcp", element: <ComplianceOverview platform="gcp" /> },

  // AWS
  { path: "/aws", element: <ComplianceOverview platform="aws" /> },

  // CrowdStrike
  { path: "/crowdstrike/azure", element: <CSComplianceOverview platform="azure" /> },
  { path: "/crowdstrike/gcp", element: <CSComplianceOverview platform="gcp" /> },
  { path: "/crowdstrike/aws", element: <CSComplianceOverview platform="aws" /> },
];


/* =========================
  Manager / Admin 共用
========================= */
export const managerRoutes = [
  {
    path: "/admin-management",
    element: <AdminManagement />,
    roles: ["manager", "edcAdmin", "admin"]
  },
  {
    path: "/company/company-base-info",
    element: <CompanyBaseInfo />,
    roles: ["manager", "edcAdmin", "admin"],
    group: "company",
    label: "基本資料"
  },
  {
    path: "/company/company-org-management",
    element: <CompanyOrgListBlock />,
    roles: ["manager", "edcAdmin", "admin"],
    group: "company",
    label: "組織管理"
  },
  {
    path: "/company/company-member-management",
    element: <CompanyMember />,
    roles: ["manager", "edcAdmin", "admin"],
    group: "company",
    label: "帳號管理"
  },
  {
    path: "/company/process-management",
    element: <ProcessManagementPage />,
    roles: ["admin"],
    group: "company",
    label: "專案管理"
  },
  {
    path: "/project/project-role-management",
    element: <ProjectRoleManagement />,
    roles: ["manager", "admin"],
    group: "project",
    label: "角色定義"
  },
  {
    path: "/project/project-member-management",
    element: <ProjectMemberManagement />,
    roles: ["manager", "admin"],
    group: "project",
    label: "專案人員管理"
  },
  {
    path: "/project/cloud-config-key",
    element: <CloudConfigKey />,
    roles: ["admin"],
    group: "admin",
    label: "ConfigKey"
  },
  {
    path: "/project/scan-schedule",
    element: <ScanScheduleSetting />,
    roles: ["admin"],
    group: "admin",
    label: "掃描排程訂閱"
  },
  {
    path: "/send-auth-key",
    element: <SendAuthCard />,
    roles: ["admin"],
    group: "admin",
    label: "系統授權管理"
  },
  {
    path: "/document-sn-management",
    element: <DocumentSnInfoManagement />,
    roles: ["edcAdmin", "admin"],
    group: "admin",
    label: "文件編號管理"
  },
];


/* =========================
  fallback（找不到頁面）
========================= */
export const fallbackRoute = {
  path: "*",
  element: <MultiCloudComplianceDashboard />,
};
